import { apiService } from './api';

const LEAD_SOURCE_MASTER_BASE_URL = '/lead-source-master';

const leadSourceMasterService = {
  // Get all lead sources with pagination and filters
  getAllLeadSources: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const url = queryParams ? `${LEAD_SOURCE_MASTER_BASE_URL}?${queryParams}` : LEAD_SOURCE_MASTER_BASE_URL;
      const response = await apiService.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead sources:', error);
      throw error;
    }
  },

  // Get lead source by ID
  getLeadSourceById: async (id) => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead source:', error);
      throw error;
    }
  },

  // Create new lead source
  createLeadSource: async (leadSourceData) => {
    try {
      const response = await apiService.post(LEAD_SOURCE_MASTER_BASE_URL, leadSourceData);
      return response.data;
    } catch (error) {
      console.error('Error creating lead source:', error);
      throw error;
    }
  },

  // Update lead source
  updateLeadSource: async (id, leadSourceData) => {
    try {
      const response = await apiService.put(`${LEAD_SOURCE_MASTER_BASE_URL}/${id}`, leadSourceData);
      return response.data;
    } catch (error) {
      console.error('Error updating lead source:', error);
      throw error;
    }
  },

  // Delete lead source
  deleteLeadSource: async (id) => {
    try {
      const response = await apiService.delete(`${LEAD_SOURCE_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting lead source:', error);
      throw error;
    }
  },

  // Get lead source statistics
  getLeadSourceStats: async () => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead source stats:', error);
      throw error;
    }
  },

  // Get active lead sources
  getActiveLeadSources: async () => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}/active`);
      return response.data;
    } catch (error) {
      console.error('Error fetching active lead sources:', error);
      throw error;
    }
  },

  // Get lead sources by category
  getLeadSourcesByCategory: async (category) => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lead sources by category:', error);
      throw error;
    }
  },

  // Get top performing lead sources
  getTopPerformingLeadSources: async (limit = 10) => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}/top-performing?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching top performing lead sources:', error);
      throw error;
    }
  },

  // Update lead source metrics
  updateLeadSourceMetrics: async (id, metricsData) => {
    try {
      const response = await apiService.put(`${LEAD_SOURCE_MASTER_BASE_URL}/${id}/metrics`, metricsData);
      return response.data;
    } catch (error) {
      console.error('Error updating lead source metrics:', error);
      throw error;
    }
  },

  // Search lead sources
  searchLeadSources: async (query) => {
    try {
      const response = await apiService.get(`${LEAD_SOURCE_MASTER_BASE_URL}?search=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Error searching lead sources:', error);
      throw error;
    }
  }
};

export default leadSourceMasterService;
